module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "actionLicencePurpose"
    }
  }, [_c('modal', {
    attrs: {
      "transition": "modal fade",
      "title": _vm.title,
      "large": ""
    },
    on: {
      "ok": function($event) {
        return _vm.ok()
      },
      "cancel": function($event) {
        return _vm.cancel()
      }
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "name": "actionPurposeForm"
    }
  }, [_c('alert', {
    attrs: {
      "show": _vm.showError,
      "type": "danger"
    },
    on: {
      "update:show": function($event) {
        _vm.showError = $event
      }
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.errorString))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.hasActionableLicencePurposes) ? _c('div', {
    staticClass: "col-sm-12"
  }, _vm._l((_vm.actionableLicencePurposes), function(purpose, index) {
    return _c('div', {
      key: ("purpose_" + index)
    }, [_c('div', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.action_licence.purpose_ids_list),
        expression: "action_licence.purpose_ids_list"
      }],
      attrs: {
        "type": "checkbox",
        "id": purpose.purpose.id
      },
      domProps: {
        "value": purpose.purpose.id,
        "checked": Array.isArray(_vm.action_licence.purpose_ids_list) ? _vm._i(_vm.action_licence.purpose_ids_list, purpose.purpose.id) > -1 : (_vm.action_licence.purpose_ids_list)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.action_licence.purpose_ids_list,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = purpose.purpose.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.action_licence, "purpose_ids_list", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.action_licence, "purpose_ids_list", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.action_licence, "purpose_ids_list", $$c)
          }
        }
      }
    }), _vm._v(" " + _vm._s(purpose.name) + "\n                                        ")])])
  }), 0) : _c('div', {
    staticClass: "col-sm-12"
  }, [_c('span', [_vm._v("You cannot apply this action to any purposes. This may be due to open applications that have yet to be processed.")])])])])])], 1)])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.actioningPurposes) ? _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "disabled": ""
    },
    on: {
      "click": _vm.ok
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(_vm._s(_vm.actioning_text) + " Purpose(s)")]) : _vm._e(), _vm._v(" "), (_vm.hasActionableLicencePurposes && !_vm.actioningPurposes) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.ok
    }
  }, [_vm._v(_vm._s(_vm.action_text) + " Purpose(s)")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Close")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cd1cf20c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/licence_action_purposes.vue
// module id = 1051
// module chunks = 0